import { settings } from "./settings";
import { getTranslation } from "./translations";

const configurator = {
  name: "KW_yconfigurator",
  currentWebsite: () => {
    return "/" + window.location.pathname.split("/")[1];
  },
  cart: {
    hmc: false,
    p: false,
    a: [],
    n: 0,
  },
};

const getLocalConfiguratorName = () => {
  return configurator.name + "_" + configurator.currentWebsite();
};

export const printCTA = () => {
  if (settings.brand == "kenwood" && settings.configurator)
    return printConfiguratorButton();
  if (settings.brand == "kenwood") return printLearnMoreBtn();
};

const printConfiguratorButton = () => {
  if (settings.brand !== "kenwood" || !settings.configurator) return;
  Array.from(
    document.querySelectorAll(".js-listing__productTile .ken-product-tile__top")
  ).forEach((el) => {
    try {
      let value = el.parentNode.querySelector("input[type=hidden]").value;
      el.parentNode.querySelector(
        "span.ken-product-tile__color-variants-label:not(.--lite)"
      ).innerHTML = "";
      const buttonContainer = document.createElement("div");
      buttonContainer.classList.add("ken-custom-hmc-buttons");
      let sku = JSON.parse(value).id;
      const configurable = el.parentNode.innerText.match(/config/gi)
      const outOfStock = [...el.parentNode.classList].includes('--out-of-stock');
      if (
        !!configurable
        && !outOfStock
        && settings.hmc.countriesDisabled.indexOf(
          window.location.pathname.split('/')[1].split('-')[1].toUpperCase()
        ) < 0
      ) {
        const button = document.createElement("button");
        button.classList.add(
          "ken-button",
          "ken-button--secondary",
          "addToConfigurator"
        );
        button.dataset.sku = sku;
        button.innerHTML = getTranslation("hmc.configurator.text");
        buttonContainer.insertAdjacentElement("beforeend", button);
        button.addEventListener("click", goToConfigurator);
      }
      const link = el.parentNode.querySelector(
        ".ken-product-tile__ctas__learn-more"
      ).href;
      const a = document.createElement("a");
      a.classList.add(
        "ken-product-tile__ctas__learn-more",
        "ken-button--primary",
        "ken-button"
      );
      a.href = link;
      a.innerHTML = getTranslation("hmc.learnmore.text");
      buttonContainer.insertAdjacentElement("beforeend", a);
      el.insertAdjacentElement("beforeend", buttonContainer);
    } catch (error) {}
  });
};

const goToConfigurator = (e) => {
  configurator.cart.hmc = e.target.dataset.sku;
  const url =
    configurator.currentWebsite() + getTranslation("hmc.configurator.url") +
    (e.target.dataset.sku ? "?productCode=" + e.target.dataset.sku : "");

  localStorage.setItem(
    getLocalConfiguratorName(),
    JSON.stringify(configurator.cart)
  );
  setTimeout(function () {
    window.location.href = url;
  }, 0);
};

const printLearnMoreBtn = () => {
  if (settings.brand !== "kenwood") return;

  Array.from(
    document.querySelectorAll(".js-listing__productTile .ken-product-tile__top")
  ).forEach((el) => {
    try {
      const buttonContainer = document.createElement("div");
      buttonContainer.classList.add("ken-custom-hmc-buttons");

      const link = el.parentNode.querySelector(
        ".ken-product-tile__ctas__learn-more"
      ).href;

      const a = document.createElement("a");
      a.classList.add(
        "ken-product-tile__ctas__learn-more",
        "ken-button--primary",
        "ken-button"
      );
      a.href = link;
      a.innerHTML = getTranslation("hmc.learnmore.text");
      buttonContainer.insertAdjacentElement("beforeend", a);

      el.insertAdjacentElement("beforeend", buttonContainer);
    } catch (error) {}
  });
};
